import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 30px;
  background-color: #ffffff;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const AdItem = styled.a`
  display: flex;
  flex: 1;
  aspect-ratio: 313/53;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }

  iframe,
  video {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    pointer-events: none !important;
  }

  /* Disable video controls in different browsers */
  video::-webkit-media-controls,
  video::-webkit-media-controls-enclosure,
  video::-webkit-media-controls-panel,
  video::-webkit-media-controls-overlay-play-button,
  video::-webkit-media-controls-play-button,
  video::-webkit-media-controls-timeline,
  video::-webkit-media-controls-current-time-display,
  video::-webkit-media-controls-time-remaining-display,
  video::-webkit-media-controls-time-remaining-display,
  video::-webkit-media-controls-mute-button,
  video::-webkit-media-controls-toggle-closed-captions-button,
  video::-webkit-media-controls-volume-slider,
  video::-webkit-media-controls-fullscreen-button {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  video::-moz-media-controls,
  video::-moz-media-controls-overlay-play-button {
    display: none !important;
  }

  video::-ms-media-controls,
  video::-ms-media-controls-play-pause,
  video::-ms-media-controls-timeline {
    display: none !important;
  }

  /* Ensure video cannot be interacted with */
  video {
    -webkit-user-modify: read-only !important;
    -moz-user-modify: read-only !important;
    -webkit-touch-callout: none !important;
  }
`;

export const FadeTransition = styled.div`
  width: 100%;
  height: 100%;
  animation: ${fadeIn} 0s ease-in-out;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;
